import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import classnames from 'classnames'
import _ from 'lodash'
import { sanitizeHtml } from '../../utils/sanitizeHtml'
import { landingPagesStatus } from 'reduxModules/landingPages'
import {
  landingPageStateSelector as stateSelector
} from 'reduxModules/landingPages/selectors'
import {
  landingPageDispatchers as dispatchers
} from 'reduxModules/landingPages/dispatchers'

import {
  TutorialSummaryPropTypes
} from 'components/generic/CourseSummary/propTypes'

import withRouterV6 from '../../utils/withRouterV6'
import Tutorial from '../generic/CourseSummary'

import './styles.css'

export class LandingPage extends Component {
  componentDidMount() {
    this.props.loadLandingPage()
  }

  getBody() {
    return { __html: sanitizeHtml(this.props.body) }
  }

  render() {
    if (this.props.status !== landingPagesStatus.success) return null

    const hasBanner = !_.isNull(this.props.banner.normal)
    const metaTitle = this.props.title || this.props.subtitle
    const metaDescription = this.props.subtitle

    return (
      <div id="LandingPage">
        <Helmet>
          <title>{metaTitle} | Stan Winston School of Character Arts</title>
          <meta name="description" content={metaDescription} />
          <meta property="og:title" content={this.props.fbTitle || metaTitle} />
          <meta property="og:description" content={this.props.fbDescription || metaDescription} />
          <meta content="article" property="og:type" />
        </Helmet>
        <section id="banner">
          <img
            src={hasBanner ? this.props.banner.normal : this.props.background.normal}
            role="presentation"
            className={classnames({ 'has-banner': hasBanner })}
            alt={this.props.subtitle}
          />
          {!hasBanner && (
            <div className="headline">
              <h1>{this.props.subtitle}</h1>
            </div>
          )}
        </section>
        <section id="content">
          {hasBanner && (
            <div className="subtitle">
              <h1>{this.props.subtitle}</h1>
            </div>
          )}
          {this.props.body && (
            <div
              className={classnames('body', { wrapper: this.props.isMobile })}
              dangerouslySetInnerHTML={this.getBody()}
            />
          )}
        </section>
        {!_.isEmpty(this.props.tutorials) && (
          <section id="tutorials" className="wrapper">
            <div className="title"><h2>Courses</h2></div>
            <div className="tutorial-list">
              {this.props.tutorials.map((tutorial) => (
                <Tutorial
                  key={`tutorial-${tutorial.id}`}
                  className="tutorial"
                  slug={tutorial.slug}
                  summary={tutorial.description}
                  teacher={tutorial.artist.title}
                  teacherSlug={tutorial.artist.slug}
                  title={tutorial.title}
                  thumb={tutorial.photo.boxThumb}
                  new={tutorial.new}
                />
              ))}
            </div>
          </section>
        )}
      </div>
    )
  }
}

LandingPage.propTypes = {
  loadLandingPage: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  banner: PropTypes.objectOf(PropTypes.string).isRequired,
  slug: PropTypes.string,
  body: PropTypes.string,
  tutorials: PropTypes
    .arrayOf(PropTypes.shape(TutorialSummaryPropTypes)).isRequired,
  isMobile: PropTypes.bool
}

LandingPage.defaultProps = {
  body: '',
  banner: {
    medium: ''
  },
  tutorials: [],
  slug: '',
  subtitle: '',
  isMobile: false
}

export default withRouterV6(connect(
  stateSelector,
  dispatchers
)(LandingPage))
